import { PromocodeFormValuesInterface } from '../data/promocode-form-values.interface';
import { PromocodeInputData } from '../data/promocode-input-data';

export const promoCodeInputDataConverter = (
  promoCodeFormValues: PromocodeFormValuesInterface
): PromocodeInputData => PromocodeInputData.fromObject(promoCodeFormValues);
